<template>
  <div id="app" v-bind:class="{mobile: this.isMobile() }">
    <header class="header" v-if="is_top_on">
        <!-- <div v-if="account.is_admin && this.is_nav">
          <button @click="view_nav()">◁◁</button>
        </div> 
        <div v-if="account.is_admin && !this.is_nav">
          <button @click="view_nav()">▷▷</button>
        </div>  -->
        <h1 class="logo">
            <router-link v-if="account.pharm_name" to="/home" class="menu-link" exact>
                <img src="./assets/menu/logo.png" alt="MDtalk" title="MDtalk" class="block">
            </router-link>
            <router-link v-else to="/" class="menu-link" exact>
                <img src="./assets/menu/logo.png" alt="MDtalk" title="MDtalk" class="block">
            </router-link>
        </h1>
        <!-- User -->
        <ul class="user">
            <!--
            <li><router-link to="/notice" class="menu-link" exact>공지사항</router-link></li>
            -->
            <li>
                <router-link v-if="account.pharm_name" to="/account" class="menu-link" exact>{{ account.pharm_name }} 님</router-link>
                <router-link v-else to="/join/1" class="menu-link" exact>회원가입</router-link>
            </li>
            <li>
                <a v-if="account.pharm_name" href="" @click.prevent="logout">로그아웃</a> <!-- 이건 따로 처리한다 -->
                <router-link v-else to="/login" class="menu-link" exact>로그인</router-link>
            </li>
        </ul>
    </header>

   <nav class="nav" v-if="is_side_on" v-show="is_nav">
      <ul class="side">
          <li class="menu1"><router-link to="/home" class="menu-link" exact>홈</router-link></li>
          <!-- <li class="menu2"><router-link to="/profile" class="menu-link" exact>약국 정보</router-link></li> -->
          <li class="menu6"><router-link tag="a" to="/account" class="menu-link" exact>회원정보관리</router-link></li>
          <li class="menu3"><router-link to="/consult-pharm" class="menu-link" exact>조제/배송 내역</router-link></li>
          <!-- <li class="menu4"><router-link to="/consult_memo" class="menu-link" exact>간단메모</router-link></li> -->
          <li class="menu5" v-if="account.is_pharm_admin"><router-link to="/consult-pharm-monit" class="menu-link" exact>조제/배송 현황</router-link></li>
          
          <li class="menu6"><router-link to="/settings" class="menu-link">설정</router-link></li>
            <ul class="side-sub" v-if="$route.name === 'settings'">
                <li><router-link to="/settings/verify" class="menu-sub">개인정보 변경</router-link></li>
                <li><router-link to="/settings/password" class="menu-sub">비밀번호 변경</router-link></li>
            </ul>          
          <!-- <li class="menu6" v-if="account.is_pharm_admin"><router-link to="/dr_admin" class="menu-link">약국 관리</router-link></li>
            <ul class="side-sub" v-if="$route.name === 'dr-admin'">
                <li><router-link to="/dr_admin/admin" class="menu-sub">약국 관리</router-link></li>
                <li><router-link to="/dr_admin/tmonit" class="menu-sub">조제/배송 관리</router-link></li>
            </ul> -->
          <!-- <li class="menu6" v-if="account.is_pharm_admin"><router-link tag="a" to="/dr_admin/tmonit" class="menu-link" exact>조제/배송 관리</router-link></li> -->
          <li class="menu6" v-if="account.is_pharm_admin"><router-link tag="a" to="/pharmacist-list" class="menu-link" exact>약사/약국 관리</router-link></li>
      </ul>
    </nav>
    <div :class="{container: is_container_on}" ref="toolbarArea">
        <router-view/>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from 'vuex'
import auth from '@/lib/auth_client'

export default {
  name: 'app',
  data() {
      return {
        is_nav: true,
      }
    },
  computed: {
    ...mapState(['account']),
    is_top_on () {
      let { top = true } = this.$route.meta
      return top
    },
    is_side_on () {
      let { side = true } = this.$route.meta
      return side
    },
    is_container_on () {
        let { container = true } = this.$route.meta
        return container
    },
  },
  methods: {
    ...mapActions({
        getPharm: 'account/getPharm',
        clearPharm: 'account/clearPharm'
    }),
    view_nav() {
      this.is_nav = !this.is_nav;
    },
    async logout () {
      // console.log('logout clicked!')
      //console.log("dr_id==============="+this.account.dr_id)
      await auth.logout()
      this.clearPharm()
      // this.$router.go(0)
      this.$router.replace('/')
    },
    auth_check () { // Todo: 나중에 이건 삭제 해야된다 vuex 사용하면 더 햇갈린다.(아래의 watch와 mounted도 지운다!)
      if (auth.isLoggedIn()) {
        // let dr_id = auth.getAuthInfo('dr_id')
        this.getPharm(auth.getAuthInfo('pharm_id'))
      }
    },
    isMobile() {
      if( screen.width <= 1024 ) {
          return true;
      }
      else {
          return false;
      }
    },
  },
  watch: {
    '$route' (to, from) {
      this.$nextTick(() => {
        this.$refs.toolbarArea.scrollTop = 0;
      });
      
      this.auth_check();
    }
  },
  async beforeMount() {
    // console.log('beforeMount', this.$route.name)
    this.auth_check();
  }
}
</script>

<style lang="scss">

  @import "vuelendar/scss/vuelendar.scss";
/*#app {*/
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
/*}*/
/*#nav {*/
  /*padding: 30px;*/
  /*a {*/
    /*font-weight: bold;*/
    /*color: #2c3e50;*/
    /*&.router-link-exact-active {*/
      /*color: #42b983;*/
    /*}*/
  /*}*/
/*}*/


    @charset "utf-8";

    img {
      image-orientation: from-image;
    }

    /* ----------------------------------------------------
        Layouts
    ------------------------------------------------------- */
    .block {
        display: block;
        width: 100%;
    }

    /* Header
    ------------------------------------------------------- */
    .header {
        width: 100%;
        height: 55px;
        z-index: 1001;
        position: relative;
        background-color: #fff;
        border-bottom: 1px solid #eaeaea;
    }

    .logo, .user {
        position: absolute;
    }

    .logo {
        width: 125px;
        height: 28px;
        top: 50%;
        left: 50px;
        margin-top: -14px;
    }

    .user {
        top: 0;
        right: 70px;
        font-size: 0;
    }

    .user > li {
        display: inline-block;
        margin-right: 25px;
    }

    .user > li:last-child {
        margin-right: 0;
    }

    .user > li > a {
        color: #323232;
        font: 400 16px/55px 'Noto Sans KR', sans-serif;
    }


    /* Side
    ------------------------------------------------------- */
    .nav {
        width: 100%;
        height: 100%;
        max-width: 200px;
        position: fixed;
        left: 0;
        top: 0;
        padding-top: 30px;
        padding-bottom: 10px;
        z-index: 1000;
        background-color: #fff;
        box-sizing: border-box;
        border-right: 1px solid #eaeaea;
        overflow-y: scroll;
    }

    .side {
        margin-top: 40px;
    }

    .side > li {
        width: 100%;
        height: 35px;
        margin-bottom: 8px;
    }

    .side > li:last-child {
        margin-bottom: 0;
    }

    .side > li > a {
        color: #444;
        display: block;
        width: 100%;
        height: 100%;
        text-indent: 60px;
        box-sizing: border-box;
        font: 400 16px/38px 'Noto Sans KR', sans-serif;
        background: url(./assets/menu/navi.jpg) 20px top no-repeat;
    }

    .side > li > a.on,
    .side > li > a:hover {
        border-right: 4px solid #736ae7;
    }

    .nav a.menu-link.router-link-active {
        border-right: 4px solid #736ae7;
    }

    .nav a.menu-sub.router-link-active {
        color: black
    }

    .side > .menu2 > a {background-position: 20px -38px;}
    .side > .menu3 > a {background-position: 20px -76px;}
    .side > .menu4 > a {background-position: 20px -114px;}
    .side > .menu5 > a {background-position: 20px -152px;}
    .side > .menu6 > a {background-position: 20px bottom;}

    .side-sub {
        margin-top: 5px;
    }

    .side-sub > li {
        color: #b1b1b1;
        text-indent: 60px;
        font: 400 14px/30px 'Noto Sans KR', sans-serif;
    }

    .side-sub > li > a {color: #b1b1b1;}
    .side-sub > li.on > a {color: #000;}

    .container {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      padding: 35px 0 0 200px;
      box-sizing: border-box;
      background-color: #f5f6fa;
      overflow-y: scroll;
    }
    .margin-left-0 {
      margin-left: 0px;
    }

    .margin-left-10 {
      margin-left: 10px;
    }

    .margin-left-100 {
      margin-left: 100px;
    }

    .margin-left-200 {
      margin-left: 200px;
    }

    .margin-left-300 {
      margin-left: 300px;
    }    

    .margin-left-400 {
      margin-left: 400px;
    }

    .margin-right-100 {
      margin-right: 100px;
    }

    .margin-right-200 {
      margin-right: 200px;
    }

    .margin-right-300 {
      margin-right: 300px;
    }

    .margin-right-400 {
      margin-right: 400px;
    }

    .margin-top-5 {
      margin-top: 5px;
    }

    .margin-top-10 {
      margin-top: 10px;
    }

    .margin-bottom-5 {
      margin-bottom: 5px;
    }

    .margin-bottom-10 {
      margin-bottom: 10px;
    }  

    .padding-width-10 {
      padding: 0px 10px;
    }



</style>
